import { Component, OnInit, Input } from '@angular/core';
import { LocalStorageService } from "angular-2-local-storage";
import { AppService } from "../../utils/app.service";
import { StateService } from '@uirouter/angular';
import { ApiService } from '../../utils/api.service';
@Component({
    selector: 'ss-landing',
    template: require('./landing.html'),
})

export class LandingComponent implements OnInit {
    _window: any;
    showSpinner = true;
    @Input() params;
    errorMsg = '';
    constructor(
        private app: AppService,
        private localStorageService: LocalStorageService,
        private stateService: StateService,
        private api: ApiService
    ) { }

    proceedWithConnection() {
        if (this.params.redirect_uri) {
            let url: any = decodeURIComponent(this.params.redirect_uri);
            window.location = url;
        } else if (this.localStorageService.get('access_token')) {
            this.localStorageService.set('token_used', 'sso');
            this.stateService.go('ss_select_business');
        } else if (JSON.parse(localStorage.getItem('portal_r.access_token'))) {
            this.localStorageService.set('access_token', JSON.parse(localStorage.getItem('portal_r.access_token')))
            this.api.resetHeaders();
            this.localStorageService.set('token_used', 'portal');
            this.stateService.go('ss_select_business');
        } else {
            this.stateService.go('login_ss');
        }
    }

    ngOnInit() {
        if (this.params.error) {
            this.errorMsg = this.params.error;
            this.showSpinner = false;
        } else {
            this.proceedWithConnection();
        }
    };
}
